<div class="widget-grid">
  <ktd-grid (layoutUpdated)="onLayoutUpdated($event)"
    (resizeEnded)="onResizeEnded($event)"
    (resizeStarted)="onResizeStarted($event)"
    [cols]="gridColumns"
    [compactType]="gridCompactType"
    [layout]="layout"
    [preventCollision]="gridSettings.preventCollision"
    [rowHeight]="gridSettings.rowHeight"
    [scrollableParent]="gridSettings.autoScroll ? document : null">

    @for (item of layout; track trackById($index, item)) {
      <ktd-grid-item (transitionend)="onTransitionEnd(item.id,$event)"
        (transitionstart)="onTransitionStart(item.id, $event)"
        [draggable]="!gridSettings.disableDrag && this.gridColumns===this.gridSettings.columns"
        [id]="item.id"
        [resizable]="!gridSettings.disableResize && this.gridColumns===this.gridSettings.columns"
        [transition]="currentTransition">
        <!-- Your grid item content goes here -->
        <div class="grid-item-content">
          <scitis-widget-item
            (moveToInteractiveDataAnalysisEvent)="onMoveToInteractiveDataAnalysis($event)"
            (removeWidgetEvent)="onWidgetRemove($event)"
            [chartId]="item.id"
            [isInEditMode]="isInEditMode"
            [isParentPageVisible]="isPageVisible"
            [isResized]="isResizeEnded[item.id]"
            [machine]="machine"
            [title]="item.name"
            [firebaseUserId]="firebaseUserId"
            [widgetItem]="getWidget(item)"
            [widgetType]="item.type"
            [forceHighChartsChartReflow]="forceHighChartsChartReflow"
            [menuItem]="menuItem"
            [isTemplateWidget]="isOnTemplatePage"
            class="chart-widget">
          </scitis-widget-item>
        </div>
      </ktd-grid-item>
    }
  </ktd-grid>
</div>
